import { render, staticRenderFns } from "./TakeBringDialog.vue?vue&type=template&id=20e553ba"
import script from "./TakeBringDialog.vue?vue&type=script&lang=js"
export * from "./TakeBringDialog.vue?vue&type=script&lang=js"
import style0 from "./TakeBringDialog.vue?vue&type=style&index=0&id=20e553ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports